// extracted by mini-css-extract-plugin
export var closeButton = "_ke-2";
export var closeButtonIcon = "_ke-3";
export var lightboxContent = "_ke-1";
export var lightboxOverlay = "_ke-0";